import { Button } from '@elements/button'
import { Modal, ModalProps } from '@elements/modal'
import useRequest from '@hooks/request'
import { useSession } from '@hooks/session'
import { useMemo } from 'react'

export interface LogoutModalProps extends ModalProps {}

export function LogoutModal({ children, ...props }: LogoutModalProps) {
  const session = useSession()

  const [logout, loggingOut] = useRequest(() => session.logout(), [session])

  const action = useMemo(
    () => ({
      status: (loggingOut ? 'loading' : 'idle') as 'loading' | 'idle',
      label: 'Logout',
      onClick: async () => {
        await logout()
        props.close()
      },
    }),
    [loggingOut, logout, props]
  )

  return (
    <Modal {...props} title='Logout?' fit className='max-w-lg'>
      <div className='space-y-6'>
        <div className='space-y-3'>
          <p>
            You are currently logged in as{' '}
            <strong>
              {session.user?.firstName} {session.user?.lastName}
            </strong>
          </p>
          <p>
            Are you sure you would like to logout? Anything unsaved on the
            screen may be lost
          </p>
        </div>
        {children}

        <Button.Primary
          className='w-full'
          loading={action.status === 'loading'}
          onClick={action.onClick}
        >
          {action.label}
        </Button.Primary>
      </div>
    </Modal>
  )
}
